module.exports = __webpack_public_path__ + "img/192.35ebd170.jpg";